// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";

import {
    ContentBlock,
    OneLinkProps
} from "../../../../components/wpl/content-block/src";
import { Link } from "../../../../components/wpl/link/src";
import {
    BGStyles,
    BGProps,
    Row
} from "../../../../libraries/wpl/foundations/src/index";

export interface InlineLogoProps {
    src: string;
    alt: string;
    link?: string;
    width?: string;
}

export interface PatternCTAMobileProps {
    inlineLogos: InlineLogoProps[];
    headerText?: string;
    bodyText?: string;
    eyebrowText?: string;
    footNoteText?: string;
    ctaProps?: OneLinkProps;
    className?: string;
    linkPosition?: "top" | "bottom";
    backgroundProperties?: BGProps;
}

const ctaPrimaryStyle = css`
    padding: 64px 0;
    text-align: center;

    ${UNSAFE_media.only.sm} {
        padding: 48px 0;
    }

    ${UNSAFE_media.below.sm} {
        padding: 32px 0;
    }

    .footnote-text {
        font-size: 0.625rem;
        text-align: left;
        margin: 30px 0 0;
    }
`;

const ConditionalLogo = (props: {
    alt: string;
    src: string;
    link?: string;
    width?: string;
}) => {
    if (props.link) {
        return (
            <a href={props.link} className="logoblock logo-linked">
                <img
                    src={props.src}
                    alt={props.alt}
                    width={props.width}
                    loading="lazy"
                />
            </a>
        );
    }
    return (
        <img
            className="logoblock logo-plain"
            src={props.src}
            alt={props.alt}
            width={props.width}
            loading="lazy"
        />
    );
};

export const PatternLogos = ({
    inlineLogos,
    headerText,
    bodyText,
    className,
    eyebrowText,
    footNoteText,
    ctaProps,
    linkPosition = "top",
    backgroundProperties
}: PatternCTAMobileProps) => {
    if (inlineLogos.length < 4 || inlineLogos.length > 12) {
        throw new Error("Minimum 4 logos required, maximum 12");
    }
    return (
        <div
            className={className}
            css={[BGStyles(backgroundProperties), ctaPrimaryStyle]}
        >
            {headerText ? (
                <Row layout="reduced">
                    <ContentBlock
                        isCentered={true}
                        headerText={headerText}
                        headerType="h2"
                        eyebrowText={eyebrowText}
                        bodyText={bodyText}
                        ctaProps={
                            linkPosition == "top" && ctaProps?.primaryLinkProps
                                ? ctaProps
                                : undefined
                        }
                    />
                </Row>
            ) : null}

            <Row>
                <div
                    className={`logos-content lgth length-${inlineLogos.length}`}
                >
                    {inlineLogos.map((inlineLogo, index) => (
                        <ConditionalLogo
                            key={index}
                            alt={inlineLogo.alt}
                            src={inlineLogo.src}
                            link={inlineLogo.link}
                            width={inlineLogo.width}
                        />
                    ))}
                </div>
            </Row>

            {footNoteText ? (
                <Row>
                    <p className="footnote-text">{footNoteText}</p>
                </Row>
            ) : null}

            {linkPosition == "bottom" && ctaProps?.primaryLinkProps ? (
                <Row>
                    <div style={{ textAlign: "center" }}>
                        <Link {...ctaProps.primaryLinkProps} />
                    </div>
                </Row>
            ) : null}
        </div>
    );
};
